import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "packing-value q-mr-md q-mb-md" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createBlock($setup["EditableToggleBlock"], {
    readonly: $props.readonly,
    "model-value": $props.catalogue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:catalogue', $event))),
    "switch-prop": "invoice_inventory",
    title: "Storage fees"
  }, {
    default: _withCtx(({ editState, editingRef }) => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "description q-mb-md" }, "Storage pricing is defined by category. Fill in the price you'd like to invoice to the client for each product category.", -1)),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storagePricingDict(editState), (value) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode($setup["CurrencyInput"], {
              readonly: $props.readonly,
              label: (value as any).name,
              "model-value": value.price,
              "onUpdate:modelValue": $event => $setup.updateValue(value, $event, editState, editingRef)
            }, null, 8, ["readonly", "label", "model-value", "onUpdate:modelValue"]),
            (editingRef.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "remove minimal danger inline q-pt-sm",
                  onClick: ($event: any) => ($setup.removePrice(value, editState, editingRef))
                }, "Remove", 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ]),
      (!$props.readonly && editingRef.value)
        ? (_openBlock(), _createBlock($setup["DButton"], {
            key: 0,
            onClick: ($event: any) => ($setup.addCategoryModal.show(editState)),
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode($setup["AddIcon"], { left: "" }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Add category price", -1))
            ]),
            _: 2
          }, 1032, ["onClick"]))
        : _createCommentVNode("", true),
      (!$props.readonly)
        ? (_openBlock(), _createBlock(_component_entry_search, {
            key: 1,
            show: $setup.addCategoryModal.visible,
            "content-type": "category",
            payload: $setup.addCategoryModal.collection,
            model: $setup.addCategoryModal.model,
            "query-handler": $setup.addCategoryModal.queryHandler,
            size: "medium",
            style: {"min-width":"320px","z-index":"9999"},
            onSelection: ($event: any) => ($setup.addCategoryModal.onSelection($event, editState, editingRef)),
            onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.addCategoryModal.visible = false))
          }, null, 8, ["show", "payload", "model", "query-handler", "onSelection"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["readonly", "model-value"]))
}